<template>
  <div>
    <form v-if="!registrationDone" @submit.prevent="handleSubmit">
            <p>Täytä alla oleva lomake ja luo ostajatunnus. Ylläpitomme käy läpi täyttämäsi tiedot ja mikäli kaikki on kunnossa, pääset tekemään tarjouksia vaurioajoneuvoista seuraavan arkipäivän aikana.</p>
            <div class="input-container">
                <input v-model="form.company" :disabled="loading" class="textinput" placeholder=" " id="company" name="company" type="text" required />
                <span class="floating-label">Yritys *</span> 
                <span v-if="errors.company !== ''" class="input-error">{{ errors.company }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.vat" :disabled="loading" class="textinput" placeholder=" " id="vat" name="vat" type="text" required />
                <span class="floating-label">Y-tunnus *</span>
                <span v-if="errors.vat !== ''" class="input-error">{{ errors.vat }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.email" :disabled="loading" class="textinput" placeholder=" " id="email" name="email" type="text" required />
                <span class="floating-label">Sähköposti *</span>
                <span v-if="errors.email !== ''" class="input-error">{{ errors.email }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.mobile" :disabled="loading" class="textinput" placeholder=" " id="mobile" name="mobile" type="text" required/>
                <span class="floating-label">Puhelinnumero *</span>
                <span v-if="errors.mobile !== ''" class="input-error">{{ errors.mobile }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.address" :disabled="loading" class="textinput" placeholder=" " id="address" name="address" type="text" required/>
                <span class="floating-label">Osoite *</span> 
                <span v-if="errors.address !== ''" class="input-error">{{ errors.address }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.zip" :disabled="loading" class="textinput" placeholder=" " id="zip" name="zip" type="text" required/>
                <span class="floating-label">Postinumero *</span> 
                <span v-if="errors.zip !== ''" class="input-error">{{ errors.zip }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.city" :disabled="loading" class="textinput" placeholder=" " id="city" name="city" type="text" required/>
                <span class="floating-label">Postitoimipaikka *</span> 
                <span v-if="errors.city !== ''" class="input-error">{{ errors.city }}</span>
            </div> 
            <div class="select-container input-container">
                <select v-model="form.country" :disabled="loading" class="select" placeholder=" " id="country" name="country" required>
                    <option v-for="country in iso31661" :value="country.alpha3">{{ country.name }}</option>
                </select>
                <i class="fa-sharp fa-regular fa-chevron-down"></i>
                <span class="floating-label">Maa *</span>
                <span v-if="errors.country !== ''" class="input-error">{{ errors.country }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.first_name" :disabled="loading" class="textinput" placeholder=" " id="first-name" name="first_name" type="text" required />
                <span class="floating-label">Etunimi *</span> 
                <span v-if="errors.first_name !== ''" class="input-error">{{ errors.first_name }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.last_name" :disabled="loading" class="textinput" placeholder=" " id="last-name" name="last_name" type="text" required />
                <span class="floating-label">Sukunimi *</span> 
                <span v-if="errors.last_name !== ''" class="input-error">{{ errors.last_name }}</span>
            </div>             
            <div class="input-container">
                <input v-model="form.password" :disabled="loading" class="textinput" placeholder=" " id="password" name="password" type="password" required />
                <span class="floating-label">Salasana *</span> 
                <span v-if="errors.password !== ''" class="input-error">{{ errors.password }}</span>
            </div> 
            <div class="input-container">
                <input v-model="form.password_confirmation" :disabled="loading" class="textinput" placeholder=" " id="password-confirmation" name="password_confirmation" type="password" required />
                <span class="floating-label">Salasana uudelleen *</span> 
                <span v-if="errors.password_confirmation !== ''" class="input-error">{{ errors.password_confirmation }}</span>
            </div> 

            <div style="margin: 1rem 0;">
                <p>Käsittelemme antamiasi henkilötietoja asian hoitamiseksi tietosuojaselosteemme mukaisesti. Lähettämällä hakemuksen, hyväksyt <a href="/kayttoehdot" class="text-body font-weight-bold text-undeline" target="_blank">käyttöehtomme</a>.</p>
                
                <input v-model="form.allow_marketing" :disabled="loading" type="checkbox" id="markkinointilupa" name="marketing">
                <label for="markkinointilupa">Annan markkinointiluvan liittyen yrityksemme palveluihin.</label>
            </div>

            <button :disabled="loading" class="button black-bg" type="submit">Luo ostajatunnus</button>
            <div v-if="generalError">
                <h3 style="color:red">Tekninen virhe!</h3>

                <p>Kokeile uudelleen hetken kuluttua. Tarvittaessa ota yhteyttä asiakaspalveluumme.</p>
            </div>
        </form> 
        <div v-else class="thank-you-for-reg">
            <h3>Kiitos mielenkiinnostasi Vaurioauton ostoportaalia kohtaan!</h3>

            <p>Järjestelmän ylläpitäjä käy läpi hakemuksesi ja on sinuun yhteydessä yhden arkipäivän kuluessa.</p>
        </div>       
    </div>
</template>

<script setup>
import { ref, inject } from 'vue';
import axios from 'axios';
import { iso31661 } from 'iso-3166'

const apiUrl = inject('apiURL');
const api = axios.create({ baseURL: apiUrl });
const loading = ref(false);
const registrationDone = ref(false);
const generalError = ref(false);

const form = ref({ 
    company: '',
    vat: '',
    email: '',
    mobile: '',
    address: '',
    zip: '',
    city: '',
    country: 'FIN',
    first_name: '',
    last_name: '',
    password: '',
    password_confirmation: '',
    allow_marketing: false,
});

// Initialize error object

// Create empty ref and inital state for errors
const errors = ref({});
const initialErrors = { 
    company: '',
    vat: '',
    email: '',
    mobile: '',
    address: '',
    zip: '',
    city: '',
    country: '',
    first_name: '',
    last_name: '',
    password: '',
    password_confirmation: '',    
};

// Define reset function
const resetErrors = () => {
    errors.value = JSON.parse(JSON.stringify(initialErrors));
    generalError.value = false;
}

// Populate initial state with reset function
resetErrors();

const handleSubmit = async () => {
    try {
        resetErrors();
        loading.value = true;
        await api.post('company/register', form.value);
        registrationDone.value = true;

        setTimeout(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});      
      }, 100);
    } catch (error) {
        if (error.response) {   
            const data = error.response.data.errors;         
            switch (error.response.status) {
                case 422:
                    Object.keys(errors.value).forEach((field) => {
                        if (field in data) {                       
                            errors.value[field] = data[field].pop();
                        }
                    });
                break;                
                default:
                    generalError.value = true;
                break;
            }
        } else if (error.request) {
            
        } else {
            
        }
    } finally {
        loading.value = false;            
    }
};


</script>

<style scoped>
</style>